module.exports = __webpack_public_path__ + "09dfb560c80d4b293379645e327ae7ea.wav";